var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _path24, _path25, _ellipse12, _ellipse13, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSerpent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "s-body",
    cx: "40%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#0d0a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050408"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s-body2",
    cx: "45%",
    cy: "40%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#221830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080610"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s-eye",
    cx: "38%",
    cy: "32%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ffcc44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#cc7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#440a00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s-maw",
    cx: "50%",
    cy: "40%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff4a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#cc4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#330800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s-void",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#180c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#0c0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#040308",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s-scale-hi",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4a3065",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0815",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "s-void-blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 140,
    rx: 85,
    ry: 75,
    fill: "url(#s-void)",
    filter: "url(#s-void-blur)",
    opacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 160,
    rx: 55,
    ry: 45,
    fill: "#0e0820",
    opacity: 0.5,
    filter: "url(#s-void-blur)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 195 C 40 185 35 168 45 155 C 55 142 75 138 95 145 C 115 152 125 165 115 178 C 105 192 85 195 65 192",
    fill: "url(#s-body)",
    stroke: "#2a1840",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 195 C 40 185 35 168 45 155 C 55 142 75 138 95 145 C 115 152 125 165 115 178 C 105 192 85 195 65 192",
    fill: "url(#s-scale-hi)",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 175 Q 65 170 75 175 Q 65 182 55 175Z",
    fill: "#3a2258",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 165 Q 88 160 98 165 Q 88 172 78 165Z",
    fill: "#3a2258",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 210 C 172 208 200 188 205 162 C 210 135 192 112 168 108 C 144 104 122 118 118 140 C 114 162 128 182 148 188 C 165 193 180 184 185 170",
    fill: "none",
    stroke: "#1a1230",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 210 C 172 208 200 188 205 162 C 210 135 192 112 168 108 C 144 104 122 118 118 140 C 114 162 128 182 148 188 C 165 193 180 184 185 170",
    fill: "none",
    stroke: "url(#s-body)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 210 C 172 208 200 188 205 162 C 210 135 192 112 168 108 C 144 104 122 118 118 140 C 114 162 128 182 148 188 C 165 193 180 184 185 170",
    fill: "none",
    stroke: "url(#s-scale-hi)",
    strokeWidth: 18,
    strokeLinecap: "round",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 168 112 Q 178 108 188 112 Q 178 120 168 112Z",
    fill: "#3a2258",
    opacity: 0.55
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 138 Q 202 132 208 138 Q 202 146 195 138Z",
    fill: "#3a2258",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 162 Q 202 156 208 162 Q 202 170 195 162Z",
    fill: "#3a2258",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 182 185 Q 188 180 194 185 Q 188 192 182 185Z",
    fill: "#3a2258",
    opacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 140 C 112 120 100 98 88 78 C 78 62 70 50 72 38",
    fill: "none",
    stroke: "#1a1230",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 140 C 112 120 100 98 88 78 C 78 62 70 50 72 38",
    fill: "none",
    stroke: "url(#s-body2)",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 140 C 112 120 100 98 88 78 C 78 62 70 50 72 38",
    fill: "none",
    stroke: "url(#s-scale-hi)",
    strokeWidth: 22,
    strokeLinecap: "round",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 125 Q 88 120 96 125 Q 88 133 80 125Z",
    fill: "#3a2258",
    opacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 72 100 Q 80 94 88 100 Q 80 107 72 100Z",
    fill: "#3a2258",
    opacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 22 C 52 10 60 2 80 2 C 100 2 115 12 118 28 C 122 44 112 58 98 64 C 82 70 60 62 55 48 C 50 38 52 30 55 22Z",
    fill: "url(#s-body)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 22 C 52 10 60 2 80 2 C 100 2 115 12 118 28 C 122 44 112 58 98 64 C 82 70 60 62 55 48 C 50 38 52 30 55 22Z",
    fill: "url(#s-scale-hi)",
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 38 C 40 42 25 48 18 56 C 14 62 20 70 32 68 C 44 66 54 56 62 48Z",
    fill: "#100c1c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 38 C 40 42 25 48 18 56 C 14 62 20 70 32 68 C 44 66 54 56 62 48Z",
    fill: "url(#s-scale-hi)",
    opacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 62 C 28 70 44 76 60 74 C 68 73 74 66 68 58 C 58 48 45 52 33 56Z",
    fill: "#0c0818"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 22 63 L 27 76 L 32 63Z",
    fill: "#c8b8d8",
    opacity: 0.8
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 38 67 L 43 80 L 48 67Z",
    fill: "#c8b8d8",
    opacity: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 24 60 L 29 48 L 34 60Z",
    fill: "#b8a8cc",
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 42 60 L 46 50 L 50 60Z",
    fill: "#b8a8cc",
    opacity: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 64,
    rx: 26,
    ry: 10,
    fill: "url(#s-maw)",
    filter: "url(#s-glow)",
    opacity: 0.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 61,
    rx: 16,
    ry: 6,
    fill: "#ffdd55",
    opacity: 0.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82,
    cy: 30,
    rx: 14,
    ry: 12,
    fill: "#080612"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82,
    cy: 30,
    rx: 14,
    ry: 12,
    fill: "url(#s-eye)",
    filter: "url(#s-glow)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82,
    cy: 30,
    rx: 8,
    ry: 7,
    fill: "#ffcc44"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82,
    cy: 30,
    rx: 3,
    ry: 4,
    fill: "#882200"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 27,
    rx: 2,
    ry: 1.5,
    fill: "#fffacc",
    opacity: 0.9
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 36,
    rx: 10,
    ry: 9,
    fill: "#080612"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 36,
    rx: 10,
    ry: 9,
    fill: "url(#s-eye)",
    filter: "url(#s-glow)",
    opacity: 0.8
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 36,
    rx: 5.5,
    ry: 5,
    fill: "#ffcc44"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 36,
    rx: 2.5,
    ry: 3,
    fill: "#882200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 62 C 10 60 5 58 2 54 C 6 56 10 56 14 55",
    fill: "none",
    stroke: "#cc4466",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 62 C 10 63 4 65 1 68 C 5 66 9 65 13 65",
    fill: "none",
    stroke: "#cc4466",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165,
    cy: 115,
    rx: 18,
    ry: 10,
    fill: "#180c28",
    opacity: 0.5,
    filter: "url(#s-void-blur)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 170,
    rx: 14,
    ry: 8,
    fill: "#180c28",
    opacity: 0.4,
    filter: "url(#s-void-blur)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 66 8 Q 90 0 110 14",
    fill: "none",
    stroke: "#cc7018",
    strokeWidth: 2,
    opacity: 0.35,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 15 Q 82 10 94 16",
    fill: "none",
    stroke: "#4a3065",
    strokeWidth: 1,
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 62 30 Q 70 26 78 30",
    fill: "none",
    stroke: "#4a3065",
    strokeWidth: 0.8,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerpent);
export default __webpack_public_path__ + "static/media/serpent.3a44e7927e56df8a1b9ff546561ef8e5.svg";
export { ForwardRef as ReactComponent };